import React from 'react';
import PageHeaderImageUrl from '../../../images/illustratie-content.svg';
import { ReactComponent as OverviewIcon } from '../../../images/icons/overview.svg';
import styles from './pageHeader.module.scss';
import { Link } from 'gatsby';

type Props = {
    backToOverviewPath?: string;
};

const PageHeader = ({ backToOverviewPath }: Props) => (
    <div className="container">
        <div className={styles.pageHeader}>
            {backToOverviewPath && (
                <Link className={styles.backToOverview} to={backToOverviewPath}>
                    <OverviewIcon />
                    <span
                        className={styles.linkText}
                        data-mobile-content="Alle platformen"
                    >
                        <span>Bekijk overzicht van alle platformen</span>
                    </span>
                </Link>
            )}

            <div className={styles.illustrationContainer}>
                <img
                    className={styles.illustration}
                    src={PageHeaderImageUrl}
                    alt="header illustratie"
                />
            </div>
        </div>
    </div>
);

export default PageHeader;
